import React from 'react';
import Button from './Button';

export const ConfirmButton = (props) => <Button buttonType="confirm" {...props} />;
export const CancelButton = (props) => <Button buttonType="cancel" {...props} />;
export const ActionButton = (props) => <Button buttonType="action" {...props} />;
export const LinkButton = (props) => <Button buttonType="link" {...props} />;
export const ContinueButton = (props) => <Button buttonType="confirm" icon="RightArrow" {...props} />;

export default Button;
